import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import auth from "../services/auth";
import Spinner from "elements/Spinner";
import AppContext from "../contexts/AppContext";
import api from "../services/api";
import emailValidate from "../services/emailValidate";
import ls from "services/ls";
import Translator, { __ } from "services/Translator";

import validator from "validator";
import swal from "sweetalert2";

import { Modal, Alert } from "react-bootstrap";
import RecoverPasswordModal from "components/loginReg/RecoverPasswordModal";
import { getAuthUiTheme } from "configs/authUiTheme";
import { resolveLoginRegTheme } from "components/loginReg/loginRegThemeRegistry";
import AuthOtpModal from "components/loginReg/AuthOtpModal";
import { isPWA } from "utils/isPWA";
import { getLoginTiming, getActivationConfig } from "utils/signupFlow";
import { isActivationRequired, showActivationRequiredNotice } from "utils/activationNotice";
import { getInitialSettings } from "utils/initialSettings";
import { fetchInitialSettings, showPostSignupPopup, shouldImmediatelyLogin } from "utils/postSignup";
import { maybeShowPostLoginBonusReminder } from "utils/postLoginBonus";

const authUiTheme = getAuthUiTheme();
const loginRegTheme = resolveLoginRegTheme(authUiTheme);
const AuthModalBody = loginRegTheme.AuthModalBody;

const LoginReg = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [spinner, setSpinner] = useState(false);

  const [showLoginModal, setShowLoginModal] = useState(false);
  const openLoginModal = () => {
    setShowLoginModal(true);
    setActiveTab("login");
    // setShowSidebar(false);
  };
  const closeLoginModal = () => {
    setShowLoginModal(false);
    setShowOtpModal(false);
    setReferralCode("");
    setShowReferralField(false);
  };

  const selectedLanguage = Translator.getSelectedLanguage();

  // tabs
  const [activeTab, setActiveTab] = useState("login");
  const toggleTab = (tabName) => {
    setActiveTab(tabName);
  };

  // recoverModal
  const [recoverPssModal, setRecoverPssModal] = useState(false);
  const openRecoverPssModal = () => {
    setRecoverPssModal(true);
    setShowLoginModal(false);
  };
  const closeRecoverPssModal = () => {
    setRecoverPssModal(false);
  };

  const [alertMsg, setAlertMsg] = useState({
    message: "Successfully added",
    variant: "success",
    showAlert: false,
  });

  const { updateUserAuthStatus, setLoginBonus } = React.useContext(AppContext);
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const [userType, setUserType] = useState(auth.getUserType);
  const [modalForgotPassword, setModalForgotPassword] = useState(
    props.modalForgotPassCall
  );

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");

  const [action, setAction] = useState(props.action ? props.action : "signup"); //signup, login depending on account exsitance
  const [selectedMenu, setSelectedMenu] = useState(props.selectedMenu);

  const switchToLogin = () => {
    closeAllModals();
    // setModalLogin(true);
    setShowLoginModal(true);
  };

  const switchToForgotPassword = () => {
    closeAllModals();
    setModalForgotPassword(true);
  };

  const closeAllModals = () => {
    // setModalLogin(false);
    setShowLoginModal(true);
    setModalForgotPassword(false);
  };

  useEffect(() => {
    // setModalLogin(props.modalLoginPropsData);
    // alert(props.modalLoginPropsData)
    if (props.modalLoginPropsData == true) {
      setShowLoginModal(props.modalLoginPropsData);
      setActiveTab("login");
      setModalForgotPassword(props.modalForgotPasswordPropsData);
    }

    console.log("props.modalSignUpPropsData", props.modalSignUpPropsData);
    if (props.modalSignUpPropsData == true) {
      setShowLoginModal(props.modalSignUpPropsData);
      setActiveTab("Sign up");
      setModalForgotPassword(props.modalForgotPasswordPropsData);
    }
  }, [props]);

  useEffect(() => {
    // In PWA mode the onboarding screen handles auth entry, so suppress the
    // automatic login/register popup.
    if (isPWA()) return;
    if (location.pathname === "/login" || location.pathname === "/register") {
      setShowLoginModal(true);
      setModalForgotPassword(false);
      if (location.pathname === "/login") {
        setActiveTab("login");
      } else if (location.pathname === "/register") {
        setActiveTab("Sign up");
      }
    } else if (location.pathname === "/recover-password") {
      openRecoverPssModal();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!showLoginModal || authUiTheme !== "streamlined") return;
    setShowReferralField(Boolean(props.referralCode));
    setReferralCode(props.referralCode || "");
  }, [showLoginModal, props.referralCode]);

  const updateEmail = (ev) => {
    setEmail(ev.target.value);
  };
  const updatePass = (ev) => {
    setPass(ev.target.value);
  };

  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
    forceLogin: true,
  });

  // Login timing (admin-configurable). 'immediate' keeps the historical
  // forceLogin bypass; 'after_verification' makes email verification mandatory
  // before login (the 423 activation gate is respected).
  const [loginTiming, setLoginTiming] = useState("immediate");
  useEffect(() => {
    let active = true;
    (async () => {
      const settings = await getInitialSettings();
      if (active && settings) setLoginTiming(getLoginTiming(settings));
    })();
    return () => {
      active = false;
    };
  }, []);

  const [signupBonusOffer, setSignupBonusOffer] = useState("no_bonus");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpSession, setOtpSession] = useState({ email: "" });
  const [referralCode, setReferralCode] = useState("");
  const [showReferralField, setShowReferralField] = useState(false);

  const [errors, setErrors] = useState({});
  const [mainErrorMgs, setMainErrorMgs] = useState("");

  const updateForm = (field, value) => {
    setLoginForm((prev) => ({ ...prev, [field]: value }));
  };

  const updateInput = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;
    updateForm(field, value);
    checkInput(ev);
  };

  const updateSelect = (a, b) => {
    var field = b.name;
    var value = a.value;
    updateForm(field, value);
  };

  const validateForm = () => {
    var valid = true;
    // return valid;
    var errorsTmp = {};

    // The login field accepts a username OR an email. If it contains "@" we hold
    // it to a real email format; otherwise we validate it as a username (length).
    if (loginForm.email.includes("@")) {
      if (!emailValidate(loginForm.email)) {
        errorsTmp = { ...errorsTmp, email: __("Please enter a valid email address") };
        valid = false;
      }
    } else if (loginForm.email.length < 2 || loginForm.email.length > 250) {
      errorsTmp = { ...errorsTmp, email: __("Please enter your username or email") };
      valid = false;
    }

    if (loginForm.password.length < 2 || loginForm.password.length > 250) {
      errorsTmp = { ...errorsTmp, password: __("Please enter your password") };
      valid = false;
    }

    setErrors(errorsTmp);

    return valid;
  };

  const [userDetails, setUserDetails] = useState(props.userDetails);

  const completeAuthSession = async (responseData) => {
    await auth.login(responseData.user);
    updateUserAuthStatus(responseData.user);
    setLoginBonus(responseData.daily_sc);
    setUserDetails(auth.getUser());
    setShowLoginModal(false);
    setShowOtpModal(false);
    history.push("/games/all");
    props.setIsAuthenticated?.(true);
    props.checkProfileCompleteness?.();
    maybeShowPostLoginBonusReminder();
  };

  const handleOtpRequested = (session) => {
    setOtpSession(session);
    setShowLoginModal(false);
    setShowOtpModal(true);
  };

  const closeOtpModal = () => {
    setShowOtpModal(false);
    setShowLoginModal(true);
  };

  const login = async (ev) => {
    ev.preventDefault();
    var valid = validateForm();
    setMainErrorMgs("");
    if (valid) {
      setSpinner(true);
      // When 'after_verification' is active, do NOT force-login past the
      // activation gate — the player must verify their email first.
      var loginPayload = { ...loginForm, forceLogin: loginTiming === "immediate" };
      var response = await api.post("/login", loginPayload);
      console.log("loginData", response);
      setSpinner(false);
      if (response.status == 200) {
        await auth.login(response.data.user);
        updateUserAuthStatus(response.data.user);
        setLoginBonus(response.data.daily_sc);
        setUserDetails(auth.getUser());
        // setRegistrationSuccessModal(true);
        setShowLoginModal(false);
        // window.location.href = "/games/all";
        history.push("/games/all");
        props.setIsAuthenticated?.(true);
        props.checkProfileCompleteness?.();
        maybeShowPostLoginBonusReminder();

        // if (response.data.daily_sc?.sc > 0) {
        //   Swal.fire({
        //     title: "Daily Bonus!",
        //     html:
        //       "<b>Congratulations!!</b><br /><p>You are eligible for SC" +
        //       response.data.daily_sc?.sc +
        //       " and GC" +
        //       response.data.daily_sc?.gc +
        //       ".<br />Claim your bonus now.",
        //     icon: "success",
        //     showCancelButton: true,
        //     focusConfirm: false,
        //     confirmButtonText: '<i class="fa fa-thumbs-up"></i> Claim Bonus!',
        //     confirmButtonAriaLabel: "Claim Bonus!",
        //     cancelButtonText: "Skip",
        //     cancelButtonAriaLabel: "Skip Bonus",
        //   }).then(async (result) => {
        //     if (result.isConfirmed) {

        //   });
        // }
      } else if (isActivationRequired(response)) {
        await showActivationRequiredNotice(loginForm.email);
      } else {
        props.showAlert(__("Login Failed"), response.data.message, true); //isError last param
      }
    }
  };

  const quickLogin = async (email, password) => {
    var response = await api.post("/login", {
      email: email,
      password: password,
      forceLogin: true,
    });
    console.log("logindetails", response);
    setSpinner(false);
    // alert(response.status);
    if (response.status == 200) {
      await auth.login(response.data.user);
      updateUserAuthStatus(response.data.user);
      setLoginBonus(response.data.daily_sc);
      setUserDetails(auth.getUser());
      // setRegistrationSuccessModal(true);
      setShowLoginModal(false);
      props.setIsAuthenticated?.(true);
      props.checkProfileCompleteness?.();
      maybeShowPostLoginBonusReminder();
    } else if (isActivationRequired(response)) {
      return await showActivationRequiredNotice(email);
    } else if (response.status == 503) {
      return new swal({
        className: props.theme,
        title: __("Login Failed"),
        text: "Login failed, please try agian.",

      });
    } else {
      return new swal({
        className: props.theme,
        title: __("Login Failed"),
        text: response.data.message,

      });
    }
  };

  const [twoFaCode, setTwoFaCode] = useState("");

  const twoFaLogin = async (ev) => {
    ev.preventDefault();
    setMainErrorMgs("");
    setSpinner(true);
    var response = await api.post("/twofa-login", { twofa_code: twoFaCode });
    console.log(response);
    setSpinner(false);
    if (response.status == 200) {
      await auth.login(response.data.user);
      updateUserAuthStatus(response.data.user);
      setLoginBonus(response.data.daily_sc);
      setShowLoginModal(false);
      props.setIsAuthenticated?.(true);
      props.checkProfileCompleteness?.();
      maybeShowPostLoginBonusReminder();
    } else {
      return new swal({
        className: props.theme,
        title: __("Invalid code"),
        text: response.data.message,

      });
    }
  };

  const resend2FaCode = async (ev) => {
    ev.preventDefault();

    setMainErrorMgs("");

    setSpinner(true);
    var response = await api.post("/resend-twofa");
    console.log(response);
    setSpinner(false);
    if (response.status == 200) {
      return new swal({
        className: props.theme,
        title: __("2FA code re-sent"),
        text: response.data.message,
        icon: "success",
      });
    }
  };

  const logout = async (ev) => {
    auth.logout();
    setUserDetails(auth.getUser());
  };

  useEffect(() => {
    // getAllCountries();
    // getLanguages();
    // getCurrencies();
    // getRegCampaigns();
  }, []);

  //Getting necessary data for registration END'S

  const handleSignupSuccess = async (email, password) => {
    setShowLoginModal(false);
    const settings = await fetchInitialSettings();
    await showPostSignupPopup(settings);
    // Login timing: log in right away, or leave the player logged out until they
    // click the activation link in their email (normal login stays gated).
    if (shouldImmediatelyLogin(settings)) {
      setSpinner(true);
      await quickLogin(email, password);
    }
  };

  // Activation landing: the backend redirects a verified player to
  // "/?verified=1&showLogin=1". Open the login module and show a short,
  // admin-configurable "you can now log in" toast, then clean the URL.
  useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    if (params.get("verified") !== "1") return;

    (async () => {
      let message = "You can now log in.";
      const settings = await getInitialSettings();
      if (settings) message = getActivationConfig(settings).message;
      if (params.get("showLogin") === "1") openLoginModal();
      swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: __(message),
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        customClass: { popup: "gcc-verify-toast" },
      });

      const cleaned = new URLSearchParams(location.search || "");
      cleaned.delete("verified");
      cleaned.delete("showLogin");
      const qs = cleaned.toString();
      history.replace(location.pathname + (qs ? `?${qs}` : ""));
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [acceptField, setAcceptField] = useState("");

  const checkInput = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;
    // alert(field);
    if (field == "email") {
      // Username-or-email field: only enforce email format when an "@" is typed.
      const looksValid = value.includes("@") ? emailValidate(value) : value.length >= 2;
      if (looksValid) {
        setAcceptField({ ...acceptField, email: 1 });
        setErrors({ ...errors, email: "" });
      } else {
        setAcceptField({ ...acceptField, email: 2 });
        setErrors({ ...errors, email: __("Please enter a valid username or email") });
      }
    }

    if (field == "password") {
      if (value.length < 2 || value.length > 250) {
        setAcceptField({ ...acceptField, password: 2 });
        setErrors({ ...errors, password: __("Please enter your password") });
      } else {
        setAcceptField({ ...acceptField, password: 1 });
        setErrors({ ...errors, password: "" });
      }
    }
  };

  return (
    <>
      {spinner && <Spinner />}
      <Modal
        size="sm"
        show={showLoginModal}
        onHide={closeLoginModal}
        centered
        backdropClassName={
          authUiTheme === "streamlined" ? "loginRegModal-backdrop--blur" : undefined
        }
        className={
          "loginRegModal " +
          loginRegTheme.modalClassName +
          " " +
          (activeTab == "Sign up" ? "regSize" : "loginSize")
        }
      >
        <Modal.Body
          className={
            authUiTheme === "streamlined"
              ? "login_modal login_modal--streamlined"
              : activeTab === "Sign up"
                ? "login_modal reg_section"
                : "login_modal "
          }
        >
          <AuthModalBody
            activeTab={activeTab}
            alertMsg={alertMsg}
            closeLoginModal={closeLoginModal}
            props={props}
            loginForm={loginForm}
            setLoginForm={setLoginForm}
            errors={errors}
            setErrors={setErrors}
            updateInput={updateInput}
            checkInput={checkInput}
            login={login}
            openRecoverPssModal={openRecoverPssModal}
            handleSignupSuccess={handleSignupSuccess}
            setSpinner={setSpinner}
            setActiveTab={setActiveTab}
            externalBonusOffer={signupBonusOffer}
            onSignupBonusChange={setSignupBonusOffer}
            referralCode={referralCode}
            setReferralCode={setReferralCode}
            showReferralField={showReferralField}
            setShowReferralField={setShowReferralField}
            onOtpRequested={handleOtpRequested}
          />
        </Modal.Body>
      </Modal>

      {authUiTheme === "streamlined" && (
        <AuthOtpModal
          show={showOtpModal}
          email={otpSession.email}
          onClose={closeOtpModal}
          onSuccess={completeAuthSession}
          onError={(message) => props.showAlert?.(__("Verification Failed"), message, true)}
          setSpinner={setSpinner}
        />
      )}

      <Modal size="lg" show={userDetails && userDetails.twoFaNeeded}>
        <Modal.Body className="login_modal">
          <div className="container-fluid">
            <div className="row">
              <div
                className={
                  activeTab === "Sign up"
                    ? "d-none d-md-block col-md-6 modalBg register"
                    : "d-none d-md-block col-md-6 modalBg login"
                }
              ></div>
              <div className="col-md-6">
                <div className="login_reg_area">
                  <Alert show={alertMsg.showAlert} variant={alertMsg.variant}>
                    {alertMsg.message}
                  </Alert>

                  <div className="form_area">
                    <form onSubmit={twoFaLogin}>
                      <div className="input_item">
                        <div className="name">
                          {__("Two FA Code")}
                          <span className="requried_icon">*</span>
                          <br />
                          <span>
                            {__(
                              "Please enter the twofa code sent to your registered email."
                            )}
                          </span>
                        </div>

                        <input
                          type="text"
                          name="twofa_code"
                          value={twoFaCode}
                          onChange={(ev) => setTwoFaCode(ev.target.value)}
                          className={
                            " name_value " + (errors.twofa_code ? "error" : "")
                          }
                        />
                        <div className="errorMsg">{errors.twofa_code}</div>
                      </div>
                      <div className="login_button">
                        <button
                          type="submit"
                          className="commonBtn filledBtn loginBtn"
                        >
                          {__("Log in")}
                        </button>
                      </div>
                    </form>
                  </div>

                  <div className="privacy_text">
                    <a href="#" onClick={resend2FaCode}>
                      {" "}
                      {__("Resend Code")}
                    </a>{" "}
                    {__("or")}
                    <a href="#" onClick={logout}>
                      {" "}
                      {__("Login with a new account")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <RecoverPasswordModal show={recoverPssModal} onHide={closeRecoverPssModal} />
    </>
  );
};

export default LoginReg;
